import config from './config';
import Axios from 'axios';

export const appointmentService = {
    getAppoinmentsByObjectID,
    getProperty,
    sendContactAppointment
};

async function getAppoinmentsByObjectID(criteria: { key: string, objectId: string }) {
    const { key, objectId } = criteria;
    return Axios({
        method: 'POST',
        url: `${config.API_URL}/client/appointment/${objectId}`,
        data: {
            key: key
        }
    });
}

async function getProperty(criteria: { key: string, objectId: string }) {
    const { key, objectId } = criteria;
    return Axios({
        method: 'POST',
        url: `${config.API_URL}/client/property/${objectId}`,
        data: {
            key: key
        }
    });
}

async function sendContactAppointment(criteria: { key: string, objectId: string, data: any, email: string }) {

    const { data, objectId, key, email } = criteria;

    const mailData = {
        'From': 'noreply@omnicasa.com',
        'To': email,
        'Bcc': 'adil@omnicasa.com',
        'HtmlBody': data.SendMail.HtmlBody,
        'Subject': data.ContactData.Subject
    };

    const payload = {
        SendMail: mailData,
        ContactData: data.ContactData,
        capchaToken: data.headers.ReCaptchaResponse,
        useCaptcha: data.headers.UseCaptcha
    };

    return Axios({
        method: 'POST',
        url: `${config.API_URL}/client/contact-appointment/${objectId}`,
        data: {
            ...payload,
            key: key
        }
    });
}
